<div class="pull-right mr-2 mt-2">
  <ngx-help-icon videoLink="https://www.loom.com/share/5bc7212212ae4e16ac910896dcfbee5c"></ngx-help-icon>
</div>
<div class="container-fluid">
  <div class="row mt-4">
    <div class="col">
      <h4 class="text-uppercase">New {{isRCDSS ? 'Contract' : 'Purchase Order'}} <span
        *ngIf="purchaseOrder?.customer_po_number"># {{ purchaseOrder.customer_po_number }}</span></h4>
    </div>
  </div>

  <mat-horizontal-stepper [linear]="true" #stepper="matHorizontalStepper"
                          (selectionChange)="stepChange($event, stepper)">
    <mat-step label="Basic Information" [completed]="!!purchaseOrder?.id">
      <div class="row">
        <div class="col-md-12">
          <ngx-po-info-step
            *ngIf="(isDraft && purchaseOrder) || !isDraft"
            [suppliers]="suppliers"
            [(purchaseOrder)]="purchaseOrder"
            (checklistChange)="checklistChanged($event)"
            [parentForm]="purchaseOrderForm"
            (discard)="deletePoDraft()"
            (saveDraft)="savePODraft()"
            (canSupplierReceivePos)="canSupplierReceivePos = $event"></ngx-po-info-step>
        </div>
      </div>
    </mat-step>

    <mat-step label="Files">
              <!-- [completed]="!!poFiles.length"> -->
      <ngx-files-step
        [purchaseOrder]="purchaseOrder"
        [(poFiles)]="poFiles"
        [isSimpleFlow]="false"
        (discard)="deletePoDraft()"
        (saveDraft)="savePODraft()"></ngx-files-step>
    </mat-step>
    <mat-step label="Subscribers">
      <ngx-po-subscribers
        *ngIf="selectedTabIndex === 2"
        [companyType]="'customer'"
        [supplierId]="purchaseOrder?.supplier_id"
        [(purchaseOrder)]="purchaseOrder"
        [(subscribers)]="subscribers"
        [isCreationMode]="true"
      ></ngx-po-subscribers>
      <div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative">

        <button class="ml-1 mr-1 button-back" type="button" mat-raised-button matStepperPrevious>Back</button>
        <button class="ml-1 mr-1" type="button" mat-raised-button color="grey" (click)="savePODraft()">
          Save to Draft
        </button>
        <button class="ml-1 mr-1" type="button" mat-raised-button color="primary" matStepperNext>Next</button>
        <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
                (click)="deletePoDraft()">
          <i class="fa fa-trash"></i>
          Discard
        </button>
      </div>

    </mat-step>
    <mat-step label="Task List">
      <ngx-checklist-step
        *ngIf="purchaseOrder"
        [(checklist)]="checklist"
        [purchaseOrder]="purchaseOrder"
        [companyType]="'customer'"
        [myStepper]="myStepper"
        (discard)="deletePoDraft()"
        (saveDraft)="savePODraft()"
      ></ngx-checklist-step>
    </mat-step>
    <mat-step label="Review and Save">
      <ngx-po-review-step
        *ngIf="selectedTabIndex === 4"
        [purchaseOrderFiles]="poFiles"
        [suppliers]="suppliers"
        [checklist]="checklist"
        (checklistChange)="checklistChanged($event)"
        [purchaseOrderInfo]="purchaseOrder"></ngx-po-review-step>

      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-warning mb-2 mt-2" *ngIf="!canSupplierReceivePos">
            <i class="fa fa-warning"></i> The selected supplier has not provided one or more of the Customer-Required
            Files defined by your company. You can keep editing this {{isRCDSS ? 'Contract' : 'Purchase Order'}} and
            save it as a draft, but you won't be able to issue it until your supplier fills all file requirements.
          </div>
        </div>
      </div>

      <div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative">
        <button class="ml-1 mr-1 button-back" type="button" mat-raised-button matStepperPrevious>Back</button>
        <button class="ml-1 mr-1" type="button" mat-raised-button color="grey" (click)="savePODraft()">
          Save to Draft
        </button>
        <button class="ml-1 mr-1" type="button" mat-raised-button color="primary"
                [disabled]="isSaving || !canSupplierReceivePos"
                (click)="createPO()">
          Send to Supplier
        </button>

        <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
                (click)="deletePoDraft()">
          <i class="fa fa-trash"></i>
          {{isRCDSS ? 'Discard Contract' : 'Discard PO'}}
        </button>
      </div>

    </mat-step>
  </mat-horizontal-stepper>


</div>
